import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "section-gallery-page" }
const _hoisted_2 = { class: "section-gallery-page__inner" }
const _hoisted_3 = { class: "section-gallery-page__panel" }
const _hoisted_4 = {
  key: 0,
  class: "section-gallery-page__empty"
}
const _hoisted_5 = {
  key: 1,
  class: "section-gallery-grid"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "section-gallery-grid__caption"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_ImageGalleryModal = _resolveComponent("ImageGalleryModal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: _ctx.blockData.page_title,
      subtitle: _ctx.blockData.subtitle
    }, null, 8 /* PROPS */, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.items.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " No gallery images in this section yet. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.id,
                  type: "button",
                  class: "section-gallery-grid__item",
                  onClick: $event => (_ctx.openGallery(index))
                }, [
                  _createElementVNode("img", {
                    src: item.image_url,
                    alt: item.caption || item.title || `Gallery image ${index + 1}`,
                    loading: "lazy"
                  }, null, 8 /* PROPS */, _hoisted_7),
                  (item.caption)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.caption), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_6))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
      ])
    ]),
    _createVNode(_component_ImageGalleryModal, {
      "is-open": _ctx.modalOpen,
      images: _ctx.imageUrls,
      captions: _ctx.captions,
      "start-index": _ctx.modalStartIndex,
      "product-name": _ctx.blockData.section_name || _ctx.blockData.page_title,
      onClose: _cache[0] || (_cache[0] = $event => (_ctx.modalOpen = false))
    }, null, 8 /* PROPS */, ["is-open", "images", "captions", "start-index", "product-name"])
  ]))
}